import { mapState, mapActions } from 'vuex'
import { BaseForm } from '@argon/app/components'
import { NAMESPACE as BOARD_NAMESPACE } from '@argon/evo/boards/store'
import { NAMESPACE as REALTIME_NAMESPACE } from '@argon/realtime/store'
import { NAMESPACE as APP_NAMESPACE } from '@argon/app/store'
import { Datatable } from '@argon/app/mixins'
import BoardMixin from './BoardMixin'
import entityPerimeter from '../perimeters'
import { NAMESPACE, TABLE } from '../store'

export default {
  name: 'EntityDatatableMixin',
  extends: BaseForm,
  perimeters: [entityPerimeter],
  mixins: [BoardMixin, Datatable],
  data: function () {
    return {
      selected: [],
      expanded: [],
      advancedSearch: false,
      expandable: false,
      headers: [
        { text: '', sortable: false, value: 'report', align: 'left', width: 30 },
        {
          text: this.$t('labels.displayName'),
          value: 'display'
        },
        {
          text: this.$t('labels.description'),
          value: 'entity.description'
        },
        {
          text: this.$t('labels.state'),
          value: 'stateObj.display',
          sortable: false
        },
        {
          text: this.$t('labels.members'),
          value: 'members',
          sortable: false
        },
        { text: '', sortable: false, value: 'actions', align: 'right', width: 100 }
      ],
      searchFields: [{ label: 'display', type: 'text' }],
      loading: true,
      counts: null,
      include: ''
    }
  },
  computed: {
    ...mapState(BOARD_NAMESPACE, ['board', 'columns', 'transitions', 'stateAttr']),
    ...mapState(NAMESPACE, ['tableItems', 'tableItemsCount']),
    context() {
      return this.boardRef
    },
    toggleLabel() {
      return this.advancedSearch ? `${this.$t('labels.hideFilters')}` : `${this.$t('labels.showFilters')}`
    },
    localHeaders() {
      return this.expandable ? [...this.headers, { text: '', value: 'data-table-expand' }] : this.headers
    },
    items() {
      return this.tableItems.map((item) => {
        let readOnly = this.$entity.isAllowed('read', item.entity) && !this.$entity.isAllowed('update', item.entity)
        // append valid transitions
        let transitions = this.transitions.filter((trs) => item[this.stateAttr] === trs.from_state)
        let stateObj = this.columns.find((state) => item[this.stateAttr] === state.name)
        return { ...item, transitions, stateObj, readOnly }
      })
    },
    realtimeKey() {
      return this.board
        ? this.$store.getters[`${REALTIME_NAMESPACE}/realtimeKey`]({
            category: `${this.board.entity_type}Tables`,
            identifier: this.boardRef
          })
        : null
    }
  },
  methods: {
    ...mapActions(REALTIME_NAMESPACE, ['addListener', 'removeListener']),
    ...mapActions(NAMESPACE, ['transit', 'listBoardItems', 'clearEntities', 'setDisplayType']),
    toggleAdvancedSearch() {
      this.advancedSearch = !this.advancedSearch
    },
    doSetToState(dtTransitionObject) {
      this.resetServerErrors()
      this.transit({
        itemId: dtTransitionObject.item.entity.id,
        transition: dtTransitionObject.transition.name,
        boardRef: this.boardRef
      })
        .catch(this.setServerErrors)
        .finally(() => {
          this.fetchData()
        })
    },
    fetchData() {
      this.loading = true
      return this.listBoardItems({
        boardRef: this.boardRef,
        pager: this.pager,
        counts: this.counts,
        include: this.include
      })
        .catch((error) => {
          if (error.status_code === 404) {
            this.$router.push({ name: 404 })
          }
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  watch: {
    realtimeKey: function (v, oldV) {
      if (oldV) {
        this.fetchData()
      }
    }
  },
  created() {
    this.setDisplayType(TABLE)
    this.fetchData().then(() => {
      this.addListener({
        category: `${this.board.entity_type}Tables`,
        identifier: this.boardRef
      })
    })
  },
  destroyed() {
    if (this.board) {
      this.removeListener({ category: `${this.board.entity_type}Tables`, identifier: this.boardRef })
    }
    this.clearEntities({ id: this.boardRef })
  }
}
